// extracted by mini-css-extract-plugin
module.exports = {"cursorLocation":"styles_cursorLocation__2n0lg"};